<template>
	<div class="planerBlockTable">
		<v-data-table
				class="planerTable"
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.valueFilter]},
                                {'dense': item.dense}]"
							:key="index"
							class=""
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									v-if="item.sortable"
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span
									class="headText wh_w"
									:class="{'headText_sorted': getSortColor(sortBy, item.value), 'center': item.value === 'optional'}">
                  {{ item.text }}
              </span>
						</div>
					</th>
<!--					<th>
						<field
								margin="0"
								padding="0"
								height="24"
								:switch-value="checkAll"
								@updateSwitch="onCheckboxAll"
								is-dense
								is-checkbox
								is-off-style
						></field>
					</th>-->
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="item.id"
							:idx="idx"
							:checkClasses="checkClasses"
							:checkAll="checkAll"
							@updateCheckOrder="onCheckOrder"
					></table-tr>
				</template>
				<tr class="tableBottom">
					<td>n: <span>{{ listItems.length }}</span></td>
					<td :key="i" v-for="i in 6"></td>
				</tr>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items && items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
	</div>
</template>

<script>
import { mapActions } from "vuex";
// components
import TableTr from "@/components/Fleet/WorkOrdersStatistics/Planer/PlanerWorkOrdersTable/TableTr/TableTr";
// shared
import Pagination from "@/shared/Pagination/Pagination";
import SortBtn from "@/shared/SortBtn/SortBtn";
// constants
import { planerWorkOrdersHeader } from "@/constants/defaultHeader";

export default {
	name: "PlanerWorkOrdersTable",
	components: {
		TableTr,
		Pagination,
		SortBtn
	},
	props: {
		listItems: Array
	},
	computed: {
		headers() {
			return planerWorkOrdersHeader;
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
	},
	watch: {
		listItems(val) {
			this.items = val;
		}
	},
	data() {
		return {
			pages: [ 10, 20, 50, 100, 200, 500 ],
			itemsPerPage: 10,
			page: 1,
			pageCount: 0,
			filterUpdate: false,
			sortBy: "id",
			sortDesc: true,
			menu: false,
			filtersMarker: {},
			filters: {},
			filtersList: {},
			list: this.listItems,
			checkClasses: {},
			filterPreloader: false,
			isRefreshPage: '',
			uniqId: { key: '', id: '' },
			isVisibleItems: false,
			checkAll: false
		};
	},
	methods: {
		...mapActions([ 'onWorkOrdersFilter', 'onWorkOrdersStatisticsFilter' ]),
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
		getSortColor(sortBy, value) {
			return sortBy === value || (sortBy && value.includes(sortBy));
		},
		toggleOrder(val) {
			const { value } = planerWorkOrdersHeader.find(item => item.value === val);
			this.sortBy = value;
			this.sortDesc = !this.sortDesc;
		},
		onCheckOrder(id) {
			this.$emit('updateCheckOrder', id);
		},
		onCheckboxAll({ value }) {
			this.checkAll = value;
			this.$emit('updateCheckOrders', value);
		}
	}
};
</script>

<style scoped lang="scss">
@import "PlanerWorkOrdersTable";
</style>

<style>
.planerTable .v-data-table__wrapper {
	max-height: 478px;
}
</style>

